"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrailingElementsContainerStyleName = exports.BreadcrumbsOverflowListStyleName = exports.BreadcrumbMenuButtonStyleName = exports.BreadcrumbDividerStyleName = exports.BreadcrumbStyleName = exports.BreadcrumbsListStyleName = exports.BreadcrumbsNavStyleName = exports.BreadcrumbsDivStyleName = exports.BreadcrumbsMenuButtonMinWidth = exports.BreadcrumbSpacing = exports.BreadcrumbDividerWidth = void 0;
var tslib_1 = require("tslib");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Colors_1 = require("../../styles/Colors");
var Flexbox_1 = require("../../styles/Flexbox");
var ListStyles_1 = require("../List/ListStyles");
exports.BreadcrumbDividerWidth = 9;
exports.BreadcrumbSpacing = 8;
exports.BreadcrumbsMenuButtonMinWidth = 30;
exports.BreadcrumbsDivStyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'inline-flex',
    margin: '9px 0',
    minWidth: exports.BreadcrumbsMenuButtonMinWidth,
    whiteSpace: 'nowrap',
    width: 'inherit',
});
exports.BreadcrumbsNavStyleName = TypeStyle.style({
    display: 'inline-block',
    whiteSpace: 'nowrap',
});
exports.BreadcrumbsListStyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    paddingLeft: 0,
});
exports.BreadcrumbStyleName = TypeStyle.style({
    color: Colors_1.TextColors.Primary,
    $nest: {
        '&.darkBackground': {
            color: Colors_1.InvertTextColors.Primary,
        },
    },
});
exports.BreadcrumbDividerStyleName = TypeStyle.style({
    color: '#333',
    display: 'inline-flex',
    margin: "0px " + exports.BreadcrumbSpacing + "px",
    width: exports.BreadcrumbDividerWidth,
    $nest: {
        '&.darkBackground': {
            color: '#bfbfbf',
        },
    },
});
exports.BreadcrumbMenuButtonStyleName = TypeStyle.style({
    width: exports.BreadcrumbsMenuButtonMinWidth,
    $nest: {
        '&&&&::after': { display: 'none' }, // no arrow icon
    },
});
exports.BreadcrumbsOverflowListStyleName = TypeStyle.style({
    listStyle: 'none',
    margin: 8,
    paddingLeft: 0,
    $nest: {
        '& li': tslib_1.__assign(tslib_1.__assign({}, Flexbox_1.AlignItemsCenter), { display: 'flex', height: ListStyles_1.ListAndMenuItemHeight }),
    }
});
exports.TrailingElementsContainerStyleName = TypeStyle.style({ flexShrink: 0 });
//# sourceMappingURL=BreadcrumbsStyles.js.map